import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { AICIPerformanceType } from 'components/AiCompetitiveIntelligence/constants';
import { getOrdinalSuffix } from 'components/View/utils';

const SmallText = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const Container = styled.div`
  .rank {
    font-size: 14px;
    font-family: var(--font-regular);
    color: var(--text-primary);

    &.leading {
      color: var(--positive-green);
    }
    &.lagging {
      color: var(--inactive-orange);
    }
  }

  .among {
    font-size: 14px;
    color: var(--text-secondary);
    margin-top: 2px;
  }
`;

type Props = {
  rank: number | null;
  performance: AICIPerformanceType | null;
  competitorsCount: number;
};

const PositionCell = ({ rank, performance, competitorsCount }: Props) => {
  if (!rank) {
    return <SmallText>-</SmallText>;
  }

  return (
    <Container>
      <div className={classNames('rank', performance)}>{getOrdinalSuffix(rank)}</div>
      {competitorsCount > 0 && (
        <div className="among">among {competitorsCount + 1} competing</div>
      )}
    </Container>
  );
};

export default PositionCell;
